import type { IConfig } from './configEnv.interface';

// Configuration for the Bus Line Recorder public site — Development
//
// This is the build deployed to https://buslinerecorder.com, which is already
// in the API's cors.accConAllowOrigin for the dev profile (it was there for
// busLineSrv, which used to occupy this host). The only calls this site makes
// are POST /user/verifyemail and POST /user/newpassword.
export const configEnvDev: IConfig = {
    name: 'development',

    api: {
        // have to stay in the API's cors.accConAllowOrigin.
        baseUrl: 'https://api.buslinerecorder.com',
        timeout: 20000,
    },

    debug: {
        enabled: true,
        logLevel: 'warn',
    },
};
